import React from "react"
import { graphql, StaticQuery } from "gatsby"
import { Link } from "gatsby"
import Tilt from 'react-vanilla-tilt'

import Layout from "../components/layout"
import SEO from "../components/seo"
import ProjectCard from "../components/projectCard"
import AreasSection from "../components/areas"
import ContactSection from "../components/contactCard"

import "../utils/normalize.css"
import "../utils/css/screen.css"
import "../utils/css/components/areas.css"

import logo from "../../content/assets/logo.png"
import dSvg from "../../content/assets/D-gradient.svg"
import arrowdown from "../../content/assets/arrow-down.svg"
import arrow from "../../content/assets/arrow-right.svg"


const DesignAreaPage = ({ data }, location) => {
    const siteTitle = data.site.siteMetadata.title
    const projects = data.allStrapiPortfoliolinks.edges

    return (
        <Layout title={siteTitle}>
            <SEO title="Albatross Designs | Creatively Crafted Digital Experiences" 
            keywords={[`brand design`, `visual design`, `interaction design`, `UI/UX design`, `User Experience`, `User Interface`, `best digital design agency`, `design company`, `graphic design agency`, `creative design agency`, `web design agency`]}
            description="Design wing of Studio Albatross aims at creating visually appealing brand stories in the form of creative digital designs. We are experts in web design, UI, UX, graphic design and logo design." />
            <section className="section-header design">
            <Link className="site-head-logo" to={`/`}>
                        <img src={logo} alt="Logo" />
                    </Link>
                <div className="mid">
                    <img src={dSvg} alt="Designs" />
                    <h1>Designs</h1>
                    <p>Creatively crafted digital experiences.</p>
                </div>
                <img className="arrow-down" src={arrowdown}></img>
            </section>
            <section className="section-description">
                <p>
                    Designs are the embodiment of a brand. A great design makes that irreversible first impression of your business. At Studio Albatross, we aim to tell the legend of your brand through lines & colours.
                    </p>
                <p>
                    From identity design to UI/UX to graphic design… we do it all that helps your story.
                    </p>
                <p className="section-description-focus">
                    The best brands have a soul… & great design holds a mirror to it.
                        </p>
            </section>
            <section className="section-offerings">
                <div className="section-title">
                    Detailed Offerings
                </div>
                <div className="offerings show-web">
                    <ul>
                        <li>UI/UX design</li>
                        <li>Logo design</li>
                        <li>Graphic design</li>
                        <li>Illustrations</li>
                        <li>Print design</li>
                        <li>Still photography</li>
                    </ul>
                    <ul>
                        <li>Brand identity design</li>
                        <li>Brand packaging</li>
                        <li>Website design & development</li>
                        <li>Social media posts</li>
                        <li>Outdoor design</li>
                        <li>Product Photography</li>
                    </ul>
                </div>
                <div className="offerings show-mob">
                    <ul>
                        <li>UI/UX design</li>
                        <li>Brand identity design</li>
                        <li>Logo design</li>
                        <li>Brand packaging</li>
                        <li>Graphic design</li>
                        <li>Website design & development</li>
                        <li>Illustrations</li>
                        <li>Social media posts</li>
                        <li>Print design</li>
                        <li>Outdoor design</li>
                        <li>Still photography</li>
                        <li>Product Photography</li>
                    </ul>
                </div>
            </section>
            <section className="section-projects">
                <div className="section-title">
                    Featured Projects
                </div>
                <div className="projects">
                    {projects.map((project, i) => (
                        <div className="project-card" key={i}>
                            <ProjectCard key={i}
                                title={project.node.title}
                                thumbnail={project.node.thumbnail}
                                link={project.node.link}
                                categories={project.node.categories}
                            />
                        </div>
                    ))}
                    <a href="http://studioalbatross.in/projects/" className="project-card">
                        <Tilt options={{ max: 25, scale: 1, glare: true }} style={{ height: '100%', width: '100%' }}>
                            <div className=" more">
                                ALL PROJECTS
                        <img className="arrow" src={arrow} alt="Start" />
                            </div>
                        </Tilt>
                    </a>
                </div>
            </section>
            <AreasSection 
                home={false}
                other={true}
                design={false}
                film={true}
                marketing={true}
            ></AreasSection>
            <ContactSection></ContactSection>
        </Layout>
    )
}

const indexQuery = graphql`
query {
    site {
        siteMetadata {
          title
        }
      }
    allStrapiPortfoliolinks(filter: {featured: {eq: true}, categories: {elemMatch: {name: {in: "Design"}}}}, limit: 3) {
      edges {
        node {
          id
          link
          title
          enabled
          featured
          thumbnail {
            childImageSharp {
              fluid(maxWidth: 400, maxHeight: 600) {
                ...GatsbyImageSharpFluid
              }
            }
          }
          categories {
            name
          }
        }
      }
    }
  }
`

export default props => (
    <StaticQuery
        query={indexQuery}
        render={data => (
            <DesignAreaPage location={props.location} data={data} {...props} />
        )}
    />
)
